"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDraft = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M21.99,6.86 L12,1 L2,6.86 L2,20 L22,20 L21.99,6.86 Z M12,13 L3.74,7.84 L12,3 L20.26,7.84 L12,13 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDraft')(IconDraft);